





import Vue from 'vue'
export default Vue.extend({
  name: 'HomeNewTitle',
  components: { },
  props:
  {
    titulo: {
      type: String,
      required: false
    },
    fecha: {
      type: String,
      required: false
    }
  }
})
